// import defaultSetting from "@/setting"

// const logo1 = require("@/assets/images/detail/01.jpg")
// const logo2 = require("@/assets/images/detail/02.png")
// const logo3 = require("@/assets/images/detail/03.png")
// const logo4 = require("@/assets/images/detail/04.png")
// const logo5 = require("@/assets/images/detail/05.png")
// const logo6 = require("@/assets/images/detail/06.png")
// const logo7 = require("@/assets/images/detail/07.png")
// const commonLogo = require("@/assets/images/detail/common.jpg")
// const logo10 = require("@/assets/images/detail/10.png")
// const logo11 = require("@/assets/images/detail/11.png")
// const logo12 = require("@/assets/images/detail/12.png")
// const logo13 = require("@/assets/images/detail/13.png")
// const logo14 = require("@/assets/images/detail/14.png")
// const logo15 = require("@/assets/images/detail/15.png")
// const logo17 = require("@/assets/images/detail/17.png")
// const logo18 = require("@/assets/images/detail/18.png")
// const logo19 = require('@/assets/images/detail/19.jpg')
// const logo20 = require("@/assets/images/detail/20.png")

const banner1 = require("@/assets/images/detail/01_banner.png")
// const banner2 = require("@/assets/images/detail/02_banner.png")
const banner3 = require("@/assets/images/detail/03_banner.png")
const banner4 = require("@/assets/images/detail/04_banner.png")
const banner5 = require("@/assets/images/detail/05_banner.png")
const banner6 = require("@/assets/images/detail/06_banner.png")
const banner7 = require("@/assets/images/detail/07_banner.png")
const banner8 = require("@/assets/images/detail/08_banner.png")
const banner9 = require("@/assets/images/detail/09_banner.jpg")
const banner10 = require("@/assets/images/detail/10_banner.png")
const banner11 = require("@/assets/images/detail/11_banner.png")
const banner12 = require("@/assets/images/detail/12_banner.png")
const banner13 = require("@/assets/images/detail/13_banner.png")
const banner14 = require("@/assets/images/detail/14_banner.jpg")
const banner15 = require("@/assets/images/detail/15_banner.png")
const banner16 = require("@/assets/images/detail/16_banner.png")
const banner17 = require("@/assets/images/detail/17_banner.png")
const banner18 = require("@/assets/images/detail/18_banner.jpg")
const banner19 = require("@/assets/images/detail/19_banner.png")
const banner20 = require("@/assets/images/detail/20_banner.jpg")
const banner21 = require("@/assets/images/detail/21_banner.jpg")
const banner22 = require("@/assets/images/detail/22_banner.png")
const banner22_02 = require("@/assets/images/detail/22_02_banner.png")
const banner23 = require("@/assets/images/detail/23_banner.png")
const brandCommon = require("@/assets/images/detail/common.jpg")

const brand2 = require("@/assets/images/brand/logo2.png")
// const brand02 = require("@/assets/images/brand/logo02.png")
const brand3 = require("@/assets/images/brand/logo3.png")
const brand03 = require("@/assets/images/brand/logo03.png")
const brand4 = require("@/assets/images/brand/logo4.png")
// const brand5 = require("@/assets/images/brand/logo5.png")
const brand6 = require("@/assets/images/brand/logo6.png")
const brand7 = require("@/assets/images/brand/logo7.png")
const brand8 = require("@/assets/images/brand/logo8.png")
const brand9 = require("@/assets/images/brand/logo9.png")
const brand10 = require("@/assets/images/brand/logo10.png")
const brand11 = require("@/assets/images/brand/logo11.png")
const brand12 = require("@/assets/images/brand/logo12.png")
const brand13 = require("@/assets/images/brand/logo13.png")

export const companyList = [
  {
    id: 1,
    logo: brandCommon,
    bannerUrl: banner1,
    title: "一汽进出口",
    name: "一汽进出口",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/259",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/259",
    content: [
      "中国第一汽车集团进出口有限公司（简称“公司”）成立于1984年，是中国第一汽车集团有限公司（简称“中国一汽”）的全资子公司。",
      "公司作为中国一汽海外事业的运营平台及对外窗口，海外业务已覆盖自主品牌整车、零部件及相关生产和维修服务设备出口，以及各种形式的地产化生产、销售、服务等相关业务。通过坚持稳健的国际化发展策略，公司各项主营业务均保持良性发展，近年营业收入持续稳定在300亿元以上规模。截至2021年底，累计进出口额达745亿美元。",
      "在出口业务方面，公司历经38年的发展，产品出口全球78个国家和地区，拥有海外一级代理120余家，在15个国家设有办事处和常驻机构，并在南非、俄罗斯、坦桑尼亚等国家设有境外子公司。整车出口产品涵盖中、重、轻、微、客、轿全系列自主产品，遍布东欧、拉美、东南亚、中东、非洲等5大区域市场，并实现了对挪威、日本等高端市场的产品突破。在“一带一路”倡议指引下，公司积极开展国际产能合作，在南非、巴基斯坦、尼日利亚、缅甸等国家建有6个海外组装生产基地。经过深入属地化运营，中国一汽产品在南非、沙特、坦桑尼亚、俄罗斯、肯尼亚等多个国家的细分市场中长期保持中国品牌销量领先地位。",
      "在进口业务方面，主要为中国一汽相关企业提供专业化的进口服务，涵盖整车、零部件、设备、原材料、技术引进、样车等方面，如奔腾、红旗、解放等自主品牌的汽车零部件及设备进口，奥迪整车、一汽丰田、一汽大众等合资品牌的整车、配件及KD散件进口。通过深入贯彻ISO9001体系标准，公司在可视化运输、智慧供应链、精细化仓储管理等方面持续为客户提供专业化进口服务。",
    ],
  },
  {
    id: 2,
    // logo: brand02,
    // bannerUrl: banner2,
    logo: brandCommon,
    bannerUrl: banner21,
    title: "一汽股权",
    name: "一汽股权",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/263",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/263",
    content: ["一汽股权投资（天津）有限公司（以下简称“公司”）成立于2018年3月，是中国第一汽车集团有限公司的全资子公司，主营业务涵盖产业投资、股权经营和资产经营。公司坚持以“价值引领，投资未来”为使命，致力于构建“直投+基金”双轮驱动的产业投资格局，打造“资本+产业”双向赋能的股权经营主体，做强“集团+社会”双翼齐飞的资产经营平台，为集团公司实现All in新能源战略转型、建设世界一流的移动出行科技公司贡献更大力量。"],
  },
  {
    id: 3,
    logo: brand03,
    bannerUrl: banner3,
    title: "一汽出行",
    name: "一汽出行",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/271",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/271",
    content: ["一汽出行成立于2018年7月25日，是中国一汽全资子公司。总部位居长春，布局东北、华北、华东、中南、西部五大区域，辐射全国40余地城市要津。拥有旗妙出行、一汽惠迪等多家合资企业，携手T3、滴滴、携程等合作伙伴。业务覆盖公务出行、网约、租赁、司服、换电等生态场景。秉承提质效、优服务、塑生态、控风险经营原则，纵智能网联之缰，揽数智算法之辔，予力社会公众美妙出行，成就不凡。"],
  },
  {
    id: 4,
    logo: brand2,
    bannerUrl: banner4,
    title: "一汽红旗",
    name: "一汽红旗",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/255",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/255",
    content: [
      "1958年，“红旗”牌轿车诞生。从此，红旗成为国家领导人和国家重大活动的国事用车。",
      "在上个世纪60至70年代，红旗轿车是中国汽车工业的一面旗帜。改革开放之后，红旗在继续承担“国车”重任的同时，不断向市场化、商业化的方向迈进。",
      "2018年1月8日，中国一汽发布新红旗品牌战略，决心把新红旗打造成为“中国第一、世界著名”的新高尚品牌，满足消费者对新时代“美好生活、美妙出行”的追求，成功地肩负起历史赋予的强大中国汽车产业的重任。",
      "新红旗的品牌理念是中国式新高尚精致主义。新红旗将突出“新高尚”、“新精致”、“新情怀”的理念，把中国传统优秀文化和世界先进文化、现代时尚设计、前沿科学技术、精细情感体验深度融合，打造体现“品味高尚、大气典雅”，“理想飞扬、激情奔放”，“精益求精、细心极致”，和“随心合意，完美体验”的卓越产品和服务。",
      "新红旗采用全新家族设计语言，以“尚·致·意”为关键，畅情表达、充分演绎“中国式新高尚精致主义”的设计理念。未来，新红旗家族将包括L、S、H、Q四大系列产品。其中：L系列，为新高尚红旗至尊车；S系列，为新高尚红旗轿跑车；H系列，为新高尚红旗主流车；Q系列，为新高尚红旗商务出行车。",
      "2018年10月30日，红旗品牌发布R.Flag“阩旗”技术品牌，并首次阐述未来的技术发展规划。R.Flag分别代表Rise升起、Future未来、Leading领先、Autonomous智能、Genes基因，预示红旗品牌升起“代表未来领先的智能基因平台”的旗帜。红旗品牌重点围绕电动化、智能网联化、体验化、共享化四大方向，全力打造R.Flag“阩旗”技术品牌。",
    ],
  },
  {
    id: 5,
    logo: brandCommon,
    bannerUrl: banner5,
    title: "一汽资本控股",
    name: "一汽资本控股",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/269",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/269",
    content: [
      "一汽资本控股有限公司立足于“扎根一汽、服务一汽，支持一汽发展”的初心使命，贯彻“核心战略支撑者、金融创新示范者、金融风险经营者、综合效益贡献者”的功能定位，加速建设成为中国一汽财务金融领域干部人才摇篮。",
      "经过长期发展，一汽资本控股有限公司已形成集信贷、保险、保理、租赁、海外金融等业务于一体的集团化汽车产业金融平台。",
    ],
  },
  {
    id: 6,
    logo: brand3,
    bannerUrl: banner6,
    title: "启明信息",
    name: "启明信息",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/265",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/265",
    content: [
      "启明信息技术股份有限公司（简称：启明信息，股票代码[002232.SZ] ）是国内领先的数字化服务提供商，公司专注于产品的研发与创新，融合云计算、区块链、大数据、人工智能等前沿技术，在企业数字运营，智慧汽车&智能网联两大领域，面向汽车制造全产业链和集团化企业管理，提供相关数字化解决方案。公司着力打造以启明星云为基础的智慧企业、智能制造、智慧供应链、智慧生态营销、智能网联、数据价值赋能等数字化产品，同时为政府提供城市智能化建设方案以及系统集成业务为核心的网络工程设计施工、数据中心建设及其运维服务。成立的22年来，启明信息累计为21个行业的10000+客户提供优质服务，伴随客户成长，帮助伙伴成功。",
    ],
  },
  {
    id: 7,
    logo: brand4,
    bannerUrl: banner7,
    title: "一汽奔腾",
    name: "一汽奔腾",
    szUrl: `/positionList?recruitType=2&projectId=201701&orgCode=0/270`,
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/270",
    content: [
      "一汽奔腾轿车有限公司是中国一汽旗下的创新创业型全资子公司，是中国一汽自主乘用车品牌战略中的中高端品牌。",
      "一汽奔腾前身可以追溯到1958年的一汽轿车厂，国产第一辆小轿车“东风金龙”以及第一辆自主品牌中高端轿车奔腾B70均在此诞生。",
      "2021年5月18日，奔腾公司发布了“向美好生活奔腾”的最新品牌战略，使新奔腾焕发出了新的生机。公司现有员工1990人，专业、年轻、生机、活力是一汽奔腾的代名词。新奔腾也将在未来出行市场大展拳脚，持续为用户出行创造惊喜！",
    ],
  },
  {
    id: 8,
    logo: brandCommon,
    bannerUrl: banner8,
    title: "一汽富华",
    name: "一汽富华",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/257",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/257",
    content: ["一汽富华生态有限公司，成立于2021年12月，前身分别为一汽集团红旗小镇事业部、长春第一汽车服务贸易有限公司。公司注册资金 1.1 亿元，现有业务涵盖汽车销售、汽车维修、汽车租赁、二手车、文化精品、文化活动、文创产品、小镇运营等范畴，是一汽集团深入发展“整车后市场”业务、做精文创、做实小镇，提升品牌价值、实现用户价值最大化的重要业务载体。"],
  },
  {
    id: 9,
    logo: brandCommon,
    bannerUrl: banner9,
    title: "一汽资产",
    name: "一汽资产",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/41",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/41",
    content: ["一汽资产经营管理有限公司是一汽集团的全资子公司，是资产盘活综合解决方案的提供者，拥有资产经营、股权管理、资产交易、招标采购、处僵治困等5大平台，始终坚持国有资产保值增值、价值最大化和市场化的原则，接管改制企业、盘活不良资产、优化股权结构、打造阳光采购，真正做到持续为客户创造价值，致力成为国内汽车行业一流的资产经营管理公司。"],
  },
  {
    id: 10,
    logo: brand6,
    bannerUrl: banner10,
    title: "一汽丰田",
    name: "一汽丰田",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/28",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/28",
    content: [
      "一汽丰田汽车有限公司是由中国第一汽车股份有限公司与日本丰田汽车倾力打造的大型汽车企业产业集群。坚守“制造更好的汽车”的初心，历经十九年风雨历程，一汽丰田已成为中国乘用车企业的中坚力量，目前拥有三个整车基地、两个发动机基地、一个研发中心、一个销售公司和一个物流公司，下设12个职能部门、分别位于天津、成都、长春、北京四地，年规划产能达94万辆，员工人数近2.1万人，累计销量达950万辆，累计营业收入突破1.37万亿元。我们用高质量绿色可持续发展为日新月异的伟大时代做出贡献。",
      "多年来，一汽丰田将丰田先进生产方式与一汽优秀管理理念完美融合，旗下投放过威驰VIOS（两厢和三厢）、卡罗拉COROLLA（燃油、双擎、双擎E+）、锐志REIZ、亚洲狮ALLION、亚洲龙AVALON（燃油、双擎）、皇冠CROWN、皇冠陆放CROWN KLUGER（双擎）、奕泽IZOA （燃油、双擎、E进擎）、RAV4荣放（燃油、双擎、双擎E+）、凌放（燃油、双擎）、锐放、普拉多PRADO、陆地巡洋舰LAND CRUISER、柯斯达COASTER等拥有卓越品质的汽车产品。在J.D. POWER、中国质量协会、C-NCAP及丰田全球服务等权威机构评定中，一汽丰田的品牌和车型历经考验，载誉连连。",
      "社会责任方面，一汽丰田积极开展与各利益相关体相互信赖、共同发展的社会贡献活动，在“交通安全”、“人才育成”、“环境保护”、“社会救助”等领域持续发力，累计投入超1.2亿元，各事业体投入公益项目超过20个，直接覆盖35万人群，间接影响人数超180万，成为备受信赖的优秀企业公民。",
      "面向未来，一汽丰田描绘了“十四五”规划蓝图和 “跨双百、翻一番”的发展路线。秉承“共创共享 量产幸福”的企业使命，一汽丰田朝着建成全价值链的、面向未来的、独立自主的合资企业努力奋斗，我们永远在路上！",
    ],
  },
  {
    id: 11,
    logo: brand7,
    bannerUrl: banner11,
    title: "一汽解放",
    name: "一汽解放",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/266",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/266",
    content: [
      "1956年，第一辆“解放”牌卡车下线，结束了新中国不能生产汽车的历史。当前，一汽解放产品涵盖重、中、轻型卡车及客车领域，拥有牵引、载货、自卸等七大品系，J7、鹰途、JH6、J6V、J6P等12个整车平台。经过近70年的发展，“解放”牌卡车经过七代产品更迭，累计销量超过800万，已经成为中国第一商用车制造企业。",
      "七大品牌：",
      "（1）企业品牌“一汽解放”，诞生于2003年1月18日，随着解放公司正式成立而得名。坚持“永求第一”的定位，践行“以客户为中心，创造无限价值”的核心价值观，诚信经营，守法经营，永续经营。",
      "（2）产品品牌“解放”，诞生于1956年，由毛主席亲自命名。坚持“持续领航”的定位，以“最低TCO、最佳信赖”为核心价值，通过提供智领全球的高品质产品让用户充分领会和体验“解放卡车、挣钱机器”带来超值收益的喜悦。",
      "（3）服务品牌“感动服务”，诞生于2002年，由当时一汽贸易总公司提出。“感动服务”品牌以“用户第一”为核心理念，践行“超越期待，直至感动”的核心价值观。2021年，一汽解放启动 “感动服务”服务领航计划，围绕“终身服务”“权益保障”“过程体验”三个角度对解放服务体系进行全面升级。",
      "（4）公益品牌“解放爱领航”，诞生于2018年，于2018年7月13日正式发布。坚持“回报社会”的定位，践行“人·车·社会和谐发展”的核心价值观。",
      "（5）生态品牌“哥伦布”，诞生于2018年，于2018年10月27日公布品牌，在2019年1月19日正式发布。坚持“智慧领航”的定位，践行“绿色、开放、创新、共享”的核心价值观，以智慧物流为核心场景，持续以新理念、新科技、新产品为生态合作伙伴赋能，为中国商用车的发展赋能，为中国物流行业的发展赋能，实现一汽解放由传统商用车制造商向智慧交通运输解决方案提供者转变的战略转型。",
      "（6）技术品牌“解放创领”，诞生于2018年，于2018年10月27日公布品牌，于2020年9月6日正式发布。坚持“价值创造”的定位，践行“创业担当、创新驱动、技术领先、产品领航”的核心价值观。其子品牌为“解放智途”“解放蓝途”“解放益途”。",
      "（7）动力域品牌“解放智慧动力域”，于2021年7月发布。 “解放智慧动力域”是“以客户为中心，面向整车与场景的软件定义动力系统解决方案”专属品牌，以商用车智慧动力域创领者为使命，以 “高智能、高可靠、低TCO”为核心价值，搭建G（绿色低碳）、H（混动低碳）、E（纯电零碳）、F（燃电零碳）四大解决方案平台，满足全部商用车的动力需求。",
      "主要产品",
      "一汽解放拥有牵引、载货、自卸、专用、新能源、轻卡、客车七大产品系列。J7、鹰途、JH6、J6V、J6P等12个卡车产品平台覆盖重、中、轻三大领域。在重卡领域，有J7、鹰途、JH6、J6V、J6P、悍V六大产品平台；在中卡领域，有J6L、JK6、龙V三大产品平台；在轻卡领域，有领途 、J6F、虎V三大产品平台；在客车领域，有传统公路车、新能源公路车、传统公交车、新能源公交车、纯电物流车、客车改装车等。",
      "面向未来，一汽解放也正在加速新能源、智能车的全面布局，在新能源方面，推出J6P纯电动自卸车、JH6纯电动牵引车、J6P燃料电池牵引车、J6F混合动力牵引车等新能源产品，倾力打造清洁高效的纯电动、混合动力、氢燃料电池车辆产品组合；在智能车方面，2020年发布全球首款量产级J7L3智能商用车，并且面向港口、环卫打造多款L4级智能专用产品，走在国际领先行列。",
    ],
  },
  {
    id: 12,
    logo: brandCommon,
    bannerUrl: banner12,
    title: "一汽物流",
    name: "一汽物流",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/264",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/264",
    content: [
      "一汽物流有限公司（以下简称“一汽物流”）是中国第一汽车集团有限公司全资子公司，始于1952年，历经69年的发展壮大，目前拥有员工1万+，建立以长春为中心，下设天津、青岛、成都及佛山等五大物流基地辐射全国，24个分拨中心为节点构建“三纵三横”物流网络，具有公路、铁路、水运等运输模式，分别在天津、青岛、成都、佛山、大连设有5个外埠全资子公司，管理仓储面积800多万平方米、可调动运力1.3万余台，配送网络遍及533个城市，服务3700余家4S店，持续为客户提供专业的产前、产中、产后一体化全价值链物流服务，一汽物流致力成为“国内顶级、世界一流”汽车物流综合解决方案提供者。",
      "一汽物流作为国内智能汽车物流技术的领航者，拥有国内领先的智能物流实验室，先后在总部建成了智能物流研发中心及信息控制中心，在天津、长春建成了国内领先的智能化立体库，并与百度合作，建成国内首个无人机整车仓储盘点系统，充分践行了“技术驱动物流、创新发展物流”理念。",
    ],
  },
  {
    id: 13,
    logo: brandCommon,
    bannerUrl: banner13,
    title: "一汽铸锻",
    name: "一汽铸锻",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/262",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/262",
    content: [
      "一汽铸造有限公司，是中国第一汽车集团股份公司的全资子公司，前身是1953年与第一汽车制造厂同步奠基兴建的铸工车间与锻工车间。",
      "历经70年的发展，一汽铸锻依托长春，布局成都、无锡、天津，形成了“四地十厂一院”的战略格局，资产总额达70多亿元，具备年产40余万吨铸锻件能力，产品主要涵盖缸体、缸盖、曲轴等发动机类铸锻件，变速箱壳体、离合器壳体等变速箱类铸件，前桥、刹车盘等底盘类铸锻件，新能源电机壳、电池壳、一体化车身结构件、副车架等车身类铸锻件；具备各类零部件的粗、精加工能力，年机加能力达120万件；具备国际先进水平的一体化模具设计制造能力，已为近百个国内外企业提供了上万套精品模具。",
    ],
  },
  {
    id: 14,
    logo: brand8,
    bannerUrl: banner14,
    title: "一汽模具",
    name: "一汽模具",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/267",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/267",
    content: [
      "一汽模具科技（长春）股份有限公司（以下简称一汽模具）是中国一汽控股子公司，溯源于1954年，总部位于吉林省长春市捷达大路1999号，占地面积34.61万平方米。历经72年发展，主要产品与服务拓展为智能机器人、智能模具、智慧焊装、轻量化零部件四大业务，为客户提供全链路、精益化、高价值的一站式解决方案。",
      "一汽模具是国家高新技术企业、国家“A级绿色工厂”，获评吉林省智能工厂、制造业单项冠军、金属冲压模具单项冠军，业务覆盖4大洲24个国家和地区、国内14个省市，服务35+家核心客户。",
      "从传统模具制造到智能装备科技，一汽模具以四大核心业务赋能客户竞争力，以技术创新驱动产业升级。",
      "智能模具以冲压智能体赋能制造升级，首件合格率超85%、出厂尺寸100%达标，侧围、翼子板、四门两盖等高端模具市占率全球前列；融合试制与高端定制能力，可年产6款试制白车身、1000台小批量总成，彰显极致典范的定制化实力。",
      "智慧焊装提供高节拍柔性焊装线体。支持“6+N”车型混线生产，依托MES系统与400余台焊接机器人实现快速换型与数字化管控。",
      "轻量化零部件拥有8条冲压线，年冲程能力2259万次，焊接结构件年产997.5万件，聚焦热成形、热气胀等前沿技术，助力汽车轻量化变革。",
      "智能机器人作为科技转型的核心引擎，布局“造车、卖车、车・生活”新赛道，打造从核心部件到整机的自主研发体系，形成大双足、小双足、轮臂机器人、四足机械狗的机器人家族矩阵，实现工业与商服场景的初步落地。",
    ],
  },
  {
    id: 15,
    logo: brand9,
    bannerUrl: banner15,
    title: "一汽大众",
    name: "一汽大众",
    szUrl: `/positionList?recruitType=2&projectId=201701&orgCode=0/258`,
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/258",
    content: [
      "一汽-大众汽车有限公司（以下简称一汽-大众）于1991年2月6日成立，是由中国第一汽车集团有限公司、德国大众汽车股份公司、奥迪汽车股份公司和大众汽车（中国）投资有限公司合资经营的大型乘用车生产企业，是我国第一个按经济规模起步建设的现代化乘用车生产企业。",
      "经过33年的发展，一汽-大众产能布局已覆盖东北长春、西南成都、华南佛山、华东青岛以及华北天津。",
      "从建厂初期的一个品牌1款产品，发展到现在的奥迪、大众、捷达三大品牌30余款产品，一汽-大众已成为国内成熟的覆盖A、B、C级全系列乘用车型的生产企业。",
        "一汽-大众在快速发展的过程中，技术研发实力不断增强。目前，公司拥有新技术开发中心、新能源中心、农安综合汽车试验场、黑河冬季试验场、造型与虚拟现实中心、车辆安全中心等重要技术中心。完备的试验手段及高精度的测试设备，保证了一汽-大众在产品预开发、本地化开发、国产化认可、零部件开发以及整车道路试验方面具有较强的技术实力。",
        "一汽-大众引用世界领先的大众集团MQB和MEB平台，生产的各个环节大量运用了在国际上具备领先优势的设备、工艺，从根本上保证了一汽-大众产品在每一个生产环节的精密和稳定。",
        "一汽-大众始终坚持将质量至上作为企业经营方针，将用户的满意和期望作为对质量始终不渝的追求，将\"创•享 高品质\"作为企业的核心品牌发展理念，同时持续开展以用户满意为重点的质量改进工作，不断规范服务流程，提升服务标准，全方位提高售前、售中和售后服务水平，为客户提供全过程、全方位的贴心服务并建立完善的客户关系管理体系。 ",
        "另外，一汽-大众还建立了覆盖全国、高效运转的营销网络，基于合作共赢的理念与经销商展开合作，通过以用户为中心的4S、城市展厅、网络营销等多种营销手段，数以万计的营销人员以高效率、人性化的服务，形成了一汽-大众强大的市场前沿。",
        "一汽-大众的快速发展带动了供应商体系的成长。一汽-大众实施了供应商综合能力提升计划，对供应商的物流体系、成本控制体系、产品开发与项目管理体系等进行联合评审，促进供应商主要业务能力全面均衡发展，确保一汽-大众的产品制造生产链在一开始就处于全面质量管理的系统之中。",
        "通过实施国内大学生招聘、海外招聘和社会招聘，一汽-大众在技术、管理领域形成人才梯队和人才储备，同时尊重员工的个人发展意愿，保持员工能力和价值的不断提升，在企业内外树立了良好的雇主品牌形象，并得到了专业机构和社会公众的广泛认同。 至今，公司已连续十余年获得Top Employers Institute 认证的“中国杰出雇主”认证，连续多年获得中华英才网评选的“全国大学生最佳雇主”汽车行业排名第一。",
        "一汽-大众将成为“中国最优秀的汽车企业，员工和伙伴心中最具活力的公司”作为公司的愿景，积极践行着“造价值经典汽车，创卓越出行服务，促人、车、社会和谐”的企业使命。在实现企业自身良好经济效益的同时，一汽-大众积极履行社会责任。一方面，一汽-大众在持续向消费者提供质量可靠的产品的同时，为地方经济发展和汽车市场繁荣贡献着自己的力量。另一方面，始终坚持环保和绿色理念，关注支持公益事业，积极倡导交通安全，并率先垂范，得到了用户的青睐、行业的拥戴和社会的认可。与此同时，企业品牌和产品品牌连年获得了政府、行业、媒体的诸多褒奖。",
        "面对行业发展的新趋势，一汽-大众结合现有战略体系，在2017年正式发布了企业“2025战略”。新的“2025战略”，充分把握外部环境的变化趋势，剖析企业自身情况，不仅关注业务发展，也将关注管理提升，承载起公司面向更长远未来的发展规划。",
        "一汽-大众正以稳健的步伐在可持续发展的道路上阔步前行。",
    ],
  },
  {
    id: 16,
    logo: brandCommon,
    bannerUrl: banner16,
    title: "能源公司",
    name: "一汽能源（长春）科技有限公司",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/268",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/268",
    content: [
      "一汽能源（长春）科技有限公司是中国第一汽车股份公司的全资子公司，位于吉林省长春市。是一汽集团本部的动能生产供应基地，负责生产经营水、电、压缩空气、天然气、高温水、采暖等动能产品，承担着集团本部汽车生产的动能供应与服务。下辖红旗解放业务事业部、大众业务事业部、运维事业部，总占地面积55.8万平方米，建筑面积8.93万平方米，有各类设备3960台套，固定资产8.92亿元，共计装备5炉8机，总装机容量67兆瓦,总供热面积460.5万平方米。",
    ],
  },
  {
    id: 17,
    logo: brand10,
    bannerUrl: banner17,
    title: "长春检测中心",
    name: "长春检测中心",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/254",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/254",
    content: [
      "长春汽车检测中心有限责任公司(英文名为Changchun Automotive Test Center Co.,Ltd.，以下简称长春汽车检测中心)位于中国汽车摇篮之城吉林省长春市，是经中国合格评定国家认可委员会认可的检测类实验室。1986年10月正式成立，有着深厚的底蕴和积淀。2017年12月，完成了公司化改制，正在以全新的姿态和稳健的步伐进入新的发展阶段。",
      "长春汽车检测中心先后被国家有关部门授权为国家汽车质量监督检验中心（长春）、汽车新产品申报《公告》国家级检测机构、汽车产品强制性认证国家级检测机构、机动车排气污染物国家级检测单位、道路运输车辆燃油消耗量检测机构、科技成果检测鉴定国家级检测机构。2017年12月，被批准为试验检测类产业技术基础公共服务平台。",
      "长春汽车检测中心设有党群人力部、综合管理部、运营管控部、技术发展部、整车部、检测工程中心、新智工程中心等部门和机构，并在大连、天津、广州、江苏等地设有外阜试验室。公司现有员工365名、固定资产7.6亿元。具有汽车整车、发动机及其附件、底盘部件、车身及其附件、电气和电子部件、驱动电机和动力电池、非金属制品及材料等的检测能力，同时具备标准制修订、认证制度和检测政策制定、检测技术和设备研发等能力。",
      "长春汽车检测中心在行使企业行为的同时承担社会责任，将一如既往的贯彻“对产品进行公正、科学的评价，为用户提供优质、完善的服务”的质量方针，为促进汽车工业的健康发展做出应有的贡献。",
    ],
  },
  {
    id: 18,
    logo: brand11,
    bannerUrl: banner18,
    title: "奥迪一汽",
    name: "奥迪一汽",
    szUrl: "https://wecruit.hotjob.cn/SU6614a2211c240e60b644bfac/pb/social.html",
    xzUrl: "https://wecruit.hotjob.cn/SU6614a2211c240e60b644bfac/pb/school.html",
    content: [
      "奥迪一汽新能源汽车有限公司成立于2021年3月25日，总部设立于吉林省长春市。",
      "Audi FAW NEV Company was established on 25th March 2021, located in Changchun, Jilin.",
      "公司建设了奥迪在华第一家专用于生产纯电动车型的生产基地, 规划年产能达15万辆。",
      "The cooperation company builds the first Audi plant site in China exclusively focusing on the production of fully electric models, with a planned annual production capacity of over 150,000 vehicles.",
      "公司计划于2024年底投产奥迪 A6 e-tron 以及奥迪Q6 e-tron 系列的三款车型, 全力推动奥迪在华车型阵容的电动化转型。",
      "Three models from the Audi A6 e-tron and Q6 e-tron series are planned to be the first put into production by the end of 2024，thus the Audi FAW NEV Company will further promote the electrification of Audi's model lineup in China.",
      "公司将致力于中德文化交汇，人才汇聚，不断推动与长春的区域合作及共同繁荣。",
      "Audi FAW NEV Company is committed to sino-German communication, bringing the best people together, and promoting regional cooperation and prosperity together with Changchun city.",
    ],
  },
  {
    id: 19,
    logo: brandCommon,
    bannerUrl: banner19,
    title: "华东试验场",
    name: "华东试验场",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/242",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/242",
    content: [
      "华东（东营）智能网联汽车试验场有限公司（简称“华东试验场公司”）于2019年11月13日成立，由中国第一汽车集团有限公司与赛轮集团股份有限公司共同出资成立，为中国一汽控股子公司。公司主要负责建设、运营华东智能网联汽车试验场。试验场总占地面积9125亩，总投资35亿元，建成后将成为国内第一、世界一流的智慧交通、智能驾驶综合研发测试平台。",
      "试验场立足时代前沿，集产业、技术、资本、区位优势于一体：",
      "一、引领技术发展。以5G、大数据、物联网、人工智能技术为支撑，资源共享、联合开发，打造集“路、车、配、云、管、端、金融”的七位一体智能交通合作平台，仿真未来智能城市交通场景，快速推进车路协同产业落地。",
      "二、背景资源雄厚。中国一汽是中国最大国有汽车企业集团，世界500强第66位，2020年销售整车突破370万辆，员工总数超15万人，总资产5888亿元，赛轮集团为国内顶级橡胶轮胎研发制造企业，中国制造业500强，2020年集团营业收入154.05亿元，致力于为全球用户提供最优质的轮胎产品及服务。华东试验场公司可充分利用股东双方的强大资源。",
      "三、规划设计先进。以国际试验场对标为基础，着眼测试科学性和先进性，全场采用柔性模块化布局，商乘分离、虚实结合。项目试验设施131.4万余平方米，运营设施19.8万余平方米，包括智能网联测试区(含封闭/半封闭/开放道路测试区)、常规性能测试区、试验室测试区、运维区等，具备智能网联驾驶测试开发、整车综合性能测试开发、公告认证与检测、汽车赛事与营销四大功能，完全满足国内乃至国际汽车测试研发需求。",
      "四、地理位置优越。东营胜利机场、东营高铁站（在建）、东营港、荣乌高速、东营城区均在公司20公里范围内，交通便捷，配套完善，业务辐射范围涵盖国内70%的汽车产能及80%的轮胎产能。",
      "同时，华东试验场具备优秀的产业带动能力。短期内将带动周边现代化服务业崛起，催生新的服务业商圈；中期将在周边孵化大批智能领域高新技术企业，并形成新的高端人才集聚区；远期将通过汽车研发与生产的纽带作用，推动全新汽车生态圈的建立，打造新的技术生态和社会生态。",
      "华东试验场公司将有力支撑国家汽车工业升级、智慧交通技术创新，弘扬时代精神，掌握核心技术，打造民族品牌，助力地方经济转型升级。华东试验场将与中国一汽、赛轮集团及合作伙伴一道，不忘产业报国之初心，砥砺前行。",
    ],
  },
  {
    id: 20,
    logo: brand12,
    bannerUrl: banner20,
    title: "机械九院",
    name: "机械九院",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/260",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/260",
    content: [
      "公司创建于1958年，为原国家机械工业部直属专业从事全国汽车工厂规划、设计和建设的甲级设计研究院，是我国研究汽车工程与制造工艺历史最长、专业最齐全、综合工程能力最强的的科技型企业。公司拥有工程设计、工程咨询、工程监理、工程总承包等18项甲级资质，凭借强大的行业地位和良好的业绩口碑，被誉为“中国汽车工厂设计的摇篮”。",
      "公司现有员工1100余人，人才队伍与技术实力处于行业领先水平。拥有全国工程勘察设计大师4人，国家及省部级及以上各类人才220人，国家级各类注册工程师270人，高级工程师及以上职称专业技术人才350余人。",
      "公司服务于大众丰田、奥迪、奔驰、宝马、特斯拉、沃尔沃、一汽、上汽、广汽、长城、吉利、小鹏等国内外众多汽车制造商，承担从汽车工厂项目选址到冲压、焊装、涂装、总装及新能源汽车电池电机等五大车间及物流系统的方案制定，从工程设计到完成工程建设、采购、验收、生产准备与调试等全部建设任务的交钥匙工程，提供汽车智能工厂全过程解决方案。60多年来公司的设计成果已遍及我国大江南北及10多个国家和地区，为我国汽车工业以及国民经济建设做出了突出贡献。",
      "公司为全国勘察设计单位百强企业，2021年全国勘察设计行业工程总承包排名第27位。公司为国家级工业设计中心、国家级高新技术企业。",
    ],
  },
  {
    id: 21,
    logo: brand13,
    bannerUrl: banner22,
    title: "中汽新能",
    name: "中汽新能",
    szUrl: "/positionList?recruitType=2&projectId=201701&orgCode=0/259601",
    xzUrl: "/positionList?recruitType=1&projectId=202301&orgCode=0/259601",
    content: [
      "中汽新能作为中国一汽控股的央企二级总部，以及央企体系内唯一的动力电池企业，肩负着产业链建设和科技创新的重要使命，是国务院国资委推动央企专业化整合的重点项目。中汽新能现有天津、无锡、青岛及滁州4大生产基地，天津、无锡两大研究院。产品主要为车载动力电池、储能动力电池，应用在电动乘用车、电动商用车、可再生能源发电并网等领域，在国际、国内拥有一大批优质客户资源。",
      "作为国家动力储能电芯研发制造高新企业，中汽新能始终把科技创新作为引领发展的第一动力，持续加大研发投入，加快研发能力建设。以研发一代、储备一代、应用一代的工作思路，不断开发新技术、推出新产品，开拓细分应用场景，提升行业竞争力。截至2025年，中汽新能公司共申请专利1410件，其中发明564件，实用新型835件，外观设计8件，国际专利3件。累计授权专利854件，其中发明111件，实用新型736件，外观设计6件，国际专利1件。",
    ],
  },
  {
    id: 22,
    logo: brandCommon,
    bannerUrl: banner22_02,
    title: "财务公司",
    name: "财务公司",
    szUrl: "/positionList?recruitType=2&orgCode=0/260501",
    xzUrl: "/positionList?recruitType=1&orgCode=0/260501",
    content: [
      "一汽财务有限公司1987年12月经中国人民银行批准成立，1988年3月正式营业，是中国一汽内首家非银行金融机构，注册资本100亿元。",
      "财务公司为中国第一汽车集团有限公司二级子公司，立足“依托集团、服务集团”，面向集团及成员单位、终端客户提供存款、资金结算、贷款、票据、即期结售汇等各类金融产品。2024年下半年起，财务公司启动业务转型调整，回归“四大平台”功能定位。2025年6月，财务公司正式挂牌司库运营中心。",
      "未来财务公司将持续释放财资管理效能，做优司库体系运营管理、做精成员单位内部金融服务、做强辅助集团财务管理职能，为中国一汽战略目标实现贡献更大价值。",
    ],
  },
  {
    id: 23,
    logo: brandCommon,
    bannerUrl: banner23,
    title: "旗新动力",
    name: "一汽旗新动力（长春）科技有限公司",
    szUrl: "/positionList?recruitType=2&orgCode=0/268",
    xzUrl: "/positionList?recruitType=1&orgCode=0/268",
    content: [
      "一汽旗新动力（长春）科技有限公司成立于2025年6月25日，总部位于吉林省长春市汽车经济技术开发区富奥大路1499号，是中国第一汽车股份有限公司全资控股的国有独资企业。公司专注于新能源动力总成产品（燃油/混动发动机、DCT变速箱、纯电/混动电驱、充/换电电池）研发、生产、销售，具备研产供销一体化运营能力，客户覆盖一汽红旗、一汽奔腾、郑州三和、云洲智能等国内知名车企、无人机、无人艇公司。",
      "公司现有凯达、轴齿、繁荣、创意、净月5个生产基地及1个研发中心，产线50条，占地面积85.6万平，人员3020人，生产基地具备发动机、变速箱与大扭矩桥组装及深加工能力，电池与电驱组装及模组、定子、转子装配能力，研发基地具备电驱动系统、电池系统、发动机及新能源系统研发、试制能力，公司现有产能218.5万，规划总产能275.2万。",
      "公司自1989年首台国产488发动机下线，至今产品已涵盖充电、换电、HEV、PHEV 4个系列16种电池总成，电量范围涵盖2.1—111kWh；纯电、混动2个系列20种电驱总成，扭矩涵盖70—300N·m；发动机5个系列9种，排量范围涵盖1.5-6.0L；变速箱2个系列3种，扭矩范围涵盖270-400N·m；匹配红旗金葵花系列车型大扭矩桥4种。",
      "伴随着红旗、奔腾品牌的高速发展，公司生产规模实现了从2020年的生产交付36万台到2024年的73万台的持续增长，年均增长19.3%，工业总产值从40亿元增长到92亿元。2025年，公司生产规模将再创新高，预计生产总成86.5万台，产值突破113亿元。近几年，随着公司对产品质量的高标准要求，总成质量市场表现持续向好，产品质量状态逐步超越合资水平，公司各项工作也得到了集团内外的高度认可，荣获中国汽车行业标杆智能工厂及集团公司多次先进党委/先进单位等荣誉称号。",
    ],
  },
]
